const formatPhoneNumber = (phoneNumber) => {
  const cleaned = String(phoneNumber).replace(/\D/g, '');
  
  if (cleaned.length !== 10) {
    return phoneNumber;
  }
  
  const areaCode = cleaned.slice(0, 3);
  const firstPart = cleaned.slice(3, 6);
  const secondPart = cleaned.slice(6, 10);
  
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};

export default formatPhoneNumber;